import React, { Suspense, useCallback, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import HeaderNavigation from './HeaderNavigation';
import PostStories from './PostStories';
import useSwipeFeed from '../lib/useSwipeFeed';
import { FeedPreviewContext } from '../lib/feedPreviewContext';

// Stay mounted across feed tabs so loaded circles and their scroll position persist.
export default function FeedTabsLayout() {
  const previews = useSwipeFeed(false);
  const [feedPosts, setFeedPosts] = useState([]);
  const sharePosts = useCallback(posts => {
    if (!posts.length) return;
    setFeedPosts(previous => {
      const byId = new Map(previous.map(post => [String(post.post_id), post]));
      posts.forEach(post => byId.set(String(post.post_id), post));
      return [...byId.values()];
    });
  }, []);
  return <div className="reference-feed">
    <PostStories posts={feedPosts} loading={previews.loading} feedSource={previews} previewOnly />
    <Header searchOnly />
    <HeaderNavigation />
    <Suspense fallback={<div className="feed-state" role="status">Loading posts…</div>}><FeedPreviewContext.Provider value={sharePosts}><Outlet /></FeedPreviewContext.Provider></Suspense>
  </div>;
}
